import * as React from "react";
import { useEffect } from "react";
import { set_range_amount } from "../actions/rangeSliderActions";
import { connect } from "react-redux";
import Nouislider from "nouislider-react";
import cookie from "react-cookies";

const RangeAmount = (props) => {
  let valuesStandart = [500, 10000, 50000]

  let { range_amount } = props.store.rangeSliderReduser;

  const range_all_sliders = {
    min: [500, 500],
    "35%": [10000, 1000],
    max: [50000],
  };

const [values, setValues] = React.useState(valuesStandart)
const [ranges, setRanges] = React.useState(range_all_sliders)

useEffect(()=>{
  setValues(valuesStandart)
  setRanges(range_all_sliders)
},[])

  const onSlide = (render, handle, value, un, percent) => {
    props.dispatch(set_range_amount(value[0].toFixed(0), percent[0].toFixed(0)));
    cookie.save("amount", value[0].toFixed(0));
  };

  const qwe = () => {
    let range = parseInt(props.store.rangeSliderReduser.range_amount);

    if (range >= 5000 && document.getElementsByClassName("noUi-marker-large")[1]) {
      document.getElementsByClassName("noUi-marker-large")[1].classList.add("secondMarker");
    } else if (
      range > 610 &&
      range < 5000 &&
      document.getElementsByClassName("noUi-marker-large")[1]
    ) {
      document.getElementsByClassName("noUi-marker-large")[1].classList.remove("secondMarker");
    }
  };
  return (
    <div id="Block-amount">
      <div id="infoBlockAmount">
        <div id="lableAmount">Оберіть суму</div>
        <output id="outputAmount">
          {range_amount}
          <span> грн</span>
        </output>
      </div>

      <div id="nouislider">
        <Nouislider
          start={3000}
          connect={"lower"}
          step={1000}
          pips={{ mode: "values", values: values, density: 4, stepped: true }}
          clickablePips
          behaviour="tap"
          range={ranges}
          onUpdate={onSlide}
        />
      </div>
      {qwe()}
    </div>
  );
}


export default connect((state) => ({ store: state }))(RangeAmount);



// WEBPACK FOOTER //
// src/rangeSliders/RangeAmount.js